import { observer } from 'mobx-react';
import * as React from 'react';
import { ActiveProgram } from '../../../../../ProgramStore/Types';
import * as style from '../../../../ProgramSummary/style.module.css';
import { TranslationsState } from '@execonline-inc/translations';
import { localizer } from '../Percentage';

interface Props {
  programDetail: ActiveProgram;
  translationsState: TranslationsState;
}

const ScheduledRunOnTrack: React.FC<Props> = ({ programDetail, translationsState }) => {
  const { percentComplete } = programDetail;

  return (
    <div
      className={style.scheduledRunOnTrack}
      data-testid="percent-complete-scheduled-run-on-track"
    >
      <p
        className={style.percentage}
        tabIndex={0}
        aria-label={`Progress: ${localizer(percentComplete)(translationsState)}`}
      >
        {localizer(percentComplete)(translationsState)}
      </p>
    </div>
  );
};

export default observer(ScheduledRunOnTrack);
